import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import AppBar from "../components/AppBar";
import Loading from "../components/Loading";
import Navbar from "../components/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../slice/tokenSlice";
import { getUser } from "../slice/userSlice";

const Auth = ({ Component }) => {
  const dispatch = useDispatch();
  const { token, error } = useSelector((state) => state.token);
  const { user, url } = useSelector((state) => state.user);
  //
  const navigate = useNavigate();
  const location = useLocation();
  const authenticate = async () => {
    const sdUser = JSON.parse(localStorage.getItem("sdUser"));
    if (!sdUser) {
      navigate("/login", { replace: true });
      return;
    }
    try {
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${sdUser}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        },
      );

      if (res.status === 200) {
        const details = res.data.data[0];
        if (
          !details.Account_Status ||
          details.Account_Status.toLowerCase() === "inactive"
        ) {
          navigate("/login", { replace: true });
          return;
        } else if (details.Account_Status.toLowerCase() === "enrolled") {
          Object.keys(details).forEach((key) => {
            if (details[key] === null) {
              details[key] = "";
            }
          });
          dispatch(getUser(details));
          //
          const res2 = await axios.get(
            `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Enrollment_Fees/search?criteria=((Lead_Name:equals:${details.id}))`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Zoho-oauthtoken ${token}`,
              },
            },
          );

          if (
            res2.status === 200 &&
            res2.data?.data[0].Payment_Status.toLowerCase() === "paid"
          ) {
            // if (location.pathname === "/user_cibil") {
            //   return;
            // }
          } else {
            // if (!details.Step || details.Step.toString() === "0") {
            //   navigate("/enroll");
            // } else if (details.Step.toString() === "1") {
            //   navigate("/select_plan");
            // } else if (details.Step.toString() === "2") {
            //   navigate("/payment");
            // } else if (details.Step.toString() === "3") {
            //   if (details.Enroll_Payment_Status.toLowerCase() === "paid") {
            //     navigate("/thankyou");
            //   } else {
            //     navigate("/payment");
            //   }
            // }
          }
        } else {
          Object.keys(details).forEach((key) => {
            if (details[key] === null) {
              details[key] = "";
            }
          });
          dispatch(getUser(details));
        }
      } else if (res.status === 204) {
        localStorage.removeItem("sdUser");
        navigate("/login", { replace: true });
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    dispatch(getToken());
  }, []);
  useEffect(() => {
    if (token !== null) {
      authenticate();
    }
  }, [location.pathname, Component, token]);

  const hideAppBarRoutes = [
    "/enroll",
    "/select_plan",
    "/payment",
    "/thankyou",
    "/creditors",
    "/help",
    "/user_cibil",
  ];
  const shouldHideAppBar = hideAppBarRoutes.includes(location.pathname);

  if (error) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-between gap-2 py-4">
        <p>{error}</p>
      </div>
    );
  }

  return user !== null ? (
    <>
      <Navbar />
      {!shouldHideAppBar && <AppBar />}
      <Component />
    </>
  ) : (
    <Loading />
  );
};

export default Auth;
